<template>
  <section>
    <div
      class="modal-card"
      style="width: auto"
    >

      <header class="modal-card-head">
        <div class="title is-bold">Edit Property Attributes</div>
      </header>

      <section class="modal-card-body">

        <div class="subtitle is-bold">Change any of the property attributes that need to be updated, then click Save Changes.</div>

        <div>Property Name</div>
        <div class="field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-model="localProperty.multifamilyAttributes.propertyName"
              type="text"
              placeholder="Property name..."
            >
          </div>
        </div>

        <div class="columns">

          <div class="column is-4">
            <div>Units</div>
            <div class="field">
              <div class="control">
                <input
                  @focus="$event.target.select()"
                  class="input"
                  v-model="localProperty.multifamilyAttributes.units"
                  type="number"
                  placeholder="Units..."
                >
              </div>
            </div>
          </div>

          <div class="column is-4">
            <div>Year Built</div>
            <div class="field">
              <div class="control">
                <input
                  @focus="$event.target.select()"
                  class="input"
                  v-model="localProperty.multifamilyAttributes.yearBuilt"
                  type="number"
                  placeholder="Year built..."
                >
              </div>
            </div>
          </div>

          <div class="column is-4">
            <div>Class</div>
            <div class="field">
              <div class="control">
                <b-select
                  expanded
                  v-model="localProperty.multifamilyAttributes.propertyClass"
                >
                  <option value="">Select class</option>
                  <option value="Class A">Class A</option>
                  <option value="Class B">Class B</option>
                  <option value="Class C">Class C</option>
                  <option value="Class D">Class D</option>
                </b-select>
              </div>
            </div>
          </div>

        </div>

        <b-message
          type="is-danger"
          has-icon
          v-if="this.errorMessage"
        >
          {{ this.errorMessage }}
        </b-message>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          @click="() => { cancel(); $parent.close() }"
        >Cancel</button>
        <button
          class="button is-primary"
          @click="() => { saveEdit(); $parent.close() }"
        >Save changes</button>
      </footer>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: "",
      localProperty: []
    };
  },

  mounted() {
    // Copy store object to local object.
    this.localProperty = JSON.parse(JSON.stringify(this.$store.state.property));

    let test = this.localProperty;
    console.log(test);
  },

  methods: {
    cancel() {
      console.log("cancel()");
    },

    async saveEdit() {
      console.log("saveEdit()");

      await this.$store
        .dispatch("updateMultifamilyPropertyAttributes", this.localProperty)
        .then(async response => {
          console.log(response);
        });

      this.$store.state.property = this.localProperty;
    }
  }
};
</script>

<style>
</style>
